export const ACCOUNT_UPDATE = "ACCOUNT_UPDATE";
export const CONTRACT_LOADED = "CONTRACT_LOADED";

export const RATE ="RATE";

export const SINGLE_ARTIST = "SINGLE_ARTIST";
